<template>
  <div id="service-screen" translate="no">
    <Loading
      :active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :height="40"
      loader="spinner"
      color="#003340"
    ></Loading>
    <WhiteHeader
      v-if="store && !(isPda && $screen.width>1018)"
      :showNavigation="false"
      :bannerImage="store.bannerLink"
      :storeImage="store.logoLink"
      :isApplication="isApplication"
      :isPda="isPda"
    ></WhiteHeader>
    <LanguageSelect
      v-if="isAbleToChangeLanguage"
      id="language-select"
      :class="{ 'language-position-in-login': isLoggedIn}"
    ></LanguageSelect>
    <ProfileDropdown
      v-if="isLoggedIn && tableType!='SELF_SERVICE_POS'"
      id="profile-dropdown"
      :isApplication="isApplication"
      :class="{ 'profile-dropdown-without-lang-select': !isAbleToChangeLanguage }"
    ></ProfileDropdown>
    <EnterPrompt
      v-else-if="!isLoggedIn && shouldShowEnterPrompt"
      @enter-clicked="initiateEntrance"
      id="enter-prompt"
      :class="{ 'enter-prompt-without-lang-select': !isAbleToChangeLanguage }"
    ></EnterPrompt>
    <div id="store-info" v-if="!(isPda && $screen.width>1018)">
      <Store id="store" :store="store" :shouldShowMenu="false"></Store>
    </div>
    <div
      id="mask"
      @click="onClickOutside"
      :class="{
        mask: isEntranceOpen || isLanguageModalOpen,
      }"
    ></div>
    <div id="body">
      <div
        id="services-container"
        style="width: 100%; height: 100%"
        v-if="(servicesToShow && servicesToShow.length > 1) || (servicesToShow && servicesToShow.length == 1 && !servicesToShow[0].restaurant.goToMenuFromServicesScreen)"
      >
        <Service
          v-for="service in servicesToShow"
          :key="service.restaurant.id"
          :service="service"
          :language="language"
          @check-menu="checkMenu"
          @go-to-open-tables="goToOpenTables"
          @go-to-open-rooms="goToOpenRooms"
          @go-to-history="goToHistory"
          @go-to-edit-catalogue="goToEditCatalogue"
        ></Service>
      </div>
    </div>
    <Footer v-if="store && store.showFluterFooter"></Footer>
    <PoweredByFooter v-else></PoweredByFooter>
  </div>
</template>

<script>
import WhiteHeader from "../WhiteHeader.vue";
import Service from "../Service.vue";
import ProfileDropdown from "../ProfileDropdown.vue";
import LanguageSelect from "../LanguageSelect";
import EnterPrompt from "../EnterPrompt.vue";
import Footer from "../Footer.vue";
import PoweredByFooter from "../PoweredByFooter.vue";
import Store from "../Store.vue";
import EntranceModal from "../EntranceModal.vue";

import MenuApi from "../../api/menu";
import UserApi from "../../api/user";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    WhiteHeader,
    Service,
    ProfileDropdown,
    LanguageSelect,
    EnterPrompt,
    Footer,
    PoweredByFooter,
    Store,
    EntranceModal,
    Loading,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEntranceOpen) {
      this.closeEntrance();
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isLanguageModalOpen) {
      this.$store.dispatch("closeLanguageModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else {
      next();
    }
  },
  async created() {
    await this.initializePage();
  },

  computed: {
    tableId() {
      return this.$store.getters.getTableId;
    },

    isLanguageModalOpen() {
      return this.$store.getters.isLanguageModalOpen;
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    loggedInUser() {
      return this.$store.getters.getUserData;
    },

    isEntranceOpen() {
      return this.$store.getters.getSlideEntranceIn;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    servicesToShow() {
      if (this.services == null || this.services == undefined || this.services.length == 0) {
        return [];
      }

      return this.services.filter((service) => !service.restaurant.hiddenForTable)
    }
  },
  data() {
    return {
      services: [],
      store: undefined,
      isLoading: false,
      increaseCounter: undefined,
      from: undefined,
      shouldShowEnterPrompt: false,
      tableType: undefined,
      isApplication: false,
      isAbleToChangeLanguage: true,
      isPda: false
    };
  },
  watch: {
    '$route.fullPath'(newPath, oldPath) {
      if (newPath !== oldPath) {
        this.initializePage();
      }
    }
  },
  methods: {

    async initializePage() {
      this.isLoading = true;
      window.scrollTo(0, 0);
      let tableId = this.$router.currentRoute.params.tableId;

      let reFetchMenuFromServer = this.$route.query.reFetchMenuFromServer == true || this.$route.query.reFetchMenuFromServer == 'true';
      let result = this.$store.getters.getStoreWithAllServices == null || reFetchMenuFromServer ? await MenuApi.getServices(tableId) : this.$store.getters.getStoreWithAllServices;

      if (!this.from || !this.from.name || !this.from.name.includes("menu")) {
        this.increaseCounter = true;
      } else {
        this.increaseCounter = false;
      }

      if (this.$route.query && this.$route.query.token != undefined && this.$route.query.token != null && this.$route.query.pdaUserId != undefined && this.$route.query.pdaUserId != null) {
        let pdaUserId = this.$route.query.pdaUserId;
        if (this.loggedInUser && this.loggedInUser.user && this.loggedInUser.user.id != pdaUserId) {
          this.$store.dispatch("setUserData", {});
          let token = this.$route.query.token;
          let response = await UserApi.loginFromToken(token, pdaUserId, result.store.id);
          if (response.status == 200) {
            this.$store.dispatch("successfullVerification");
            this.$store.dispatch("setUserData", response.user);
          }
        } else if (this.loggedInUser && (this.loggedInUser.user == undefined || this.loggedInUser.user == null)) {
          let token = this.$route.query.token;
          let response = await UserApi.loginFromToken(token, pdaUserId, result.store.id);
          if (response.status == 200) {
            this.$store.dispatch("successfullVerification");
            this.$store.dispatch("setUserData", response.user);
          }
        }
      }

      this.$store.dispatch("setStoreId", result.store.id);

      let menusToBeShown = result.menus.filter(menu => !menu.restaurant.hiddenForTable);

      if (menusToBeShown.length == 1 && menusToBeShown[0].restaurant.goToMenuFromServicesScreen) {
        let restaurant = menusToBeShown[0].restaurant;
        let currentTable = menusToBeShown[0].table;
        let originTableParameter = currentTable.showOriginTableIfRedirect ? `?originTableId=${currentTable.id}` : '';

        let clientId = this.$route.query && this.$route.query.clientId != undefined ? this.$route.query.clientId : null;
        let querySymbol = originTableParameter == '' ? '?' : '&';
        let clientIdParameter = clientId != null ? `${querySymbol}clientId=${clientId}` : '';

        let redirectLinkBasedOnLanguage = restaurant.names.translation[this.language].redirectLink;
        if (redirectLinkBasedOnLanguage != null && redirectLinkBasedOnLanguage.trim().length > 0) {
          window.location.href = redirectLinkBasedOnLanguage + originTableParameter + clientIdParameter;
        } else if (restaurant.redirectLink) {
          window.location.href = restaurant.redirectLink + originTableParameter + clientIdParameter;
        } else {
          this.store = result.store;
          result.menus = menusToBeShown;
          let routeToPush = currentTable.pda ? "pda-menu" : "menu";
          this.$router.push({
            name: routeToPush,
            params: {
              tableId: tableId,
              service: restaurant.routeName,
              increaseCounter: this.increaseCounter,
              menu: result,
            },
            query: this.$router.currentRoute.query
          });
        }

      } else {


        let extraLanguages = [];
        result.menus.forEach(menu => {
          if (menu.restaurant.customItems && menu.restaurant.customItems.EXTRA_LANGUAGE != null && menu.restaurant.customItems.EXTRA_LANGUAGE.trim().length != 0) {
            let extraLanguagesOfRestaurant = menu.restaurant.customItems.EXTRA_LANGUAGE.split(",");
            extraLanguagesOfRestaurant.forEach(extraLanguageOfRestaurant => extraLanguages.push(extraLanguageOfRestaurant));
          }
        });

        if (extraLanguages.length > 0) {
          this.$store.dispatch("setExtraLanguages", extraLanguages);
        }

        this.$store.dispatch("setStoreWithAllServices", result);
        this.$store.dispatch("setTableId", tableId);
        this.$store.dispatch("setTablePda", result.menus[0].table.pda);
        this.isPda = result.menus[0].table.pda;
        this.services = result.menus;
        this.tableType = result.menus[0].table.type;
        this.isApplication = result.menus[0].table.application;
        this.store = result.store;

        // we show enterprompt only for non read_only stores
        // in order to avoid unecassary logins and not to get charged
        this.shouldShowEnterPrompt = this.store.pricingPackage != "READ_ONLY";

        if (this.shouldShowEnterPrompt && !this.isPda && this.tableType != 'SELF_SERVICE_POS') {
          this.shouldShowEnterPrompt = this.services.some(serviceOfStore => serviceOfStore.restaurant.verifiedOrdersEnabled);
        }

        this.isAbleToChangeLanguage = result.store.ableToChangeLanguage;
        if (result.store.ableToChangeLanguage) {
          try {
            let navigatorLanguage = navigator.language;
            if (navigatorLanguage == 'el') {
              this.$store.dispatch("setDefaultLanguage", 'GRE');
            } else {
              this.$store.dispatch("setDefaultLanguage", result.store.language);
            }
          } catch (error) {
            this.$store.dispatch("setDefaultLanguage", result.store.language);
          }
        } else {
          this.$store.dispatch("setLanguageOnlyToMemory", result.store.language);
        }

        this.isLoading = false;
      }
    },

    onClickOutside: function (event) {
      if (this.isEntranceOpen && event.target.id == "mask") {
        this.closeEntrance();
      } else if (this.isLanguageModalOpen) {
        this.$store.dispatch("closeLanguageModal");
      }
    },

    initiateEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceIn");
    },

    closeEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceOut");
      this.$store.dispatch("shouldNotSlideEntranceIn");

      setTimeout(() => {
        this.$store.dispatch("resetEntranceState");
        this.$store.dispatch("setEntranceMessage", "");

        this.$store.dispatch("resetVerificationState");
        this.$store.dispatch("setVerificationMessage", "");
      }, 850);
    },

    checkMenu: function (id) {

      let tableId = this.$router.currentRoute.params.tableId;
      let menu = {
        store: this.store,
        menus: this.services.filter((service) => service.restaurant.id == id),
      };

      let restaurant = menu.menus[0].restaurant;
      let currentTable = menu.menus[0].table

      if (currentTable.pda && this.store && this.store.pinProtected && (this.isLoggedIn == undefined || this.isLoggedIn == null || this.isLoggedIn == false)) {
        this.initiateEntrance();
        return;
      }

      if (currentTable.pda && this.store && this.store.pinProtected && this.loggedInUser && this.loggedInUser.user && !this.loggedInUser.user.verified) {
        this.$store.dispatch("setUserData", {});
        this.initiateEntrance();
        return;
      }

      this.isLoading = true;

      let redirectLinkBasedOnLanguage = restaurant.names.translation[this.language].redirectLink;
      if (redirectLinkBasedOnLanguage != null && redirectLinkBasedOnLanguage.trim().length > 0) {
        let currentTableId = this.$router.currentRoute.params.tableId;
        let originTableParameter = currentTable.showOriginTableIfRedirect ? `&originTableId=${currentTableId}` : '';

        let clientId = this.$route.query && this.$route.query.clientId != undefined ? this.$route.query.clientId : null;
        let clientIdParameter = clientId != null ? `&clientId=${clientId}` : '';

        window.location.href = redirectLinkBasedOnLanguage + `?backTo=${currentTableId}${originTableParameter}${clientIdParameter}`;
      } else if (restaurant.redirectLink) {
        let currentTableId = this.$router.currentRoute.params.tableId;
        let originTableParameter = currentTable.showOriginTableIfRedirect ? `&originTableId=${currentTableId}` : '';

        let clientId = this.$route.query && this.$route.query.clientId != undefined ? this.$route.query.clientId : null;
        let clientIdParameter = clientId != null ? `&clientId=${clientId}` : '';

        if (restaurant.redirectLink.includes("/redirect-menu/")) {
          let queryObject = {
            backTo: currentTableId
          };
          if (currentTable.showOriginTableIfRedirect) {
            queryObject.originTableId = currentTableId;
          }
          if (clientId != null) {
            queryObject.clientId = clientId;
          }

          queryObject.reFetchMenuFromServer = true;

          const url = new URL(restaurant.redirectLink);

          this.$router.push({
            path: url.pathname,
            query: queryObject
          });
        } else {
          window.location.href = restaurant.redirectLink + `?backTo=${currentTableId}${originTableParameter}${clientIdParameter}`;
        }


      } else {
        let routeToPush = currentTable.pda ? "pda-menu" : "menu";
        this.$router.push({
          name: routeToPush,
          params: {
            tableId: tableId,
            service: restaurant.routeName,
            increaseCounter: this.increaseCounter,
            menu: menu,
          },
          query: this.$router.currentRoute.query
        });
        this.isLoading = false;
      }
    },

    goToEditCatalogue() {
      if (this.isLoggedIn == undefined || this.isLoggedIn == null || this.isLoggedIn == false) {
        this.initiateEntrance();
        return;
      }

      if (this.loggedInUser && this.loggedInUser.user && !this.loggedInUser.user.verified) {
        this.$store.dispatch("setUserData", {});
        this.initiateEntrance();
        return;
      }

      let tableId = this.$router.currentRoute.params.tableId;
      this.isLoading = true;
      this.$router.push({
        name: "edit-catalogue",
        params: {
          storeId: this.store.id,
          tableId: tableId,
          store: this.store
        },
      });
      this.isLoading = false;
    },

    goToHistory() {
      if (this.isLoggedIn == undefined || this.isLoggedIn == null || this.isLoggedIn == false) {
        this.initiateEntrance();
        return;
      }

      if (this.loggedInUser && this.loggedInUser.user && !this.loggedInUser.user.verified) {
        this.$store.dispatch("setUserData", {});
        this.initiateEntrance();
        return;
      }

      let tableId = this.$router.currentRoute.params.tableId;
      this.isLoading = true;
      this.$router.push({
        name: "store-order-history",
        params: {
          storeId: this.store.id,
          tableId: tableId,
          store: this.store
        },
      });
      this.isLoading = false;
    },

    goToOpenTables() {

      if (this.isLoggedIn == undefined || this.isLoggedIn == null || this.isLoggedIn == false) {
        this.initiateEntrance();
        return;
      }

      if (this.loggedInUser && this.loggedInUser.user && !this.loggedInUser.user.verified) {
        this.$store.dispatch("setUserData", {});
        this.initiateEntrance();
        return;
      }

      let tableId = this.$router.currentRoute.params.tableId;
      this.isLoading = true;
      this.$router.push({
        name: "open-tables",
        params: {
          storeId: this.store.id,
          tableId: tableId,
          store: this.store
        },
      });
      this.isLoading = false;
    },

    goToOpenRooms() {

      if (this.isLoggedIn == undefined || this.isLoggedIn == null || this.isLoggedIn == false) {
        this.initiateEntrance();
        return;
      }

      if (this.loggedInUser && this.loggedInUser.user && !this.loggedInUser.user.verified) {
        this.$store.dispatch("setUserData", {});
        this.initiateEntrance();
        return;
      }

      let tableId = this.$router.currentRoute.params.tableId;
      this.isLoading = true;
      this.$router.push({
        name: "open-rooms",
        params: {
          storeId: this.store.id,
          tableId: tableId,
          store: this.store
        },
      });
      this.isLoading = false;
    },
  },
};
</script>
<style scoped>
#body {
  display: flex;
  flex-direction: column;

  /* grid-template-columns: auto;
  grid-auto-flow: row dense; */
  background: #f7f7f7;
  width: 100%;
  min-height: 60vh;
  align-items: center;
  padding: 5vh 15vw 5vh 15vw;
}
@media screen and (max-width: 1018px) {
  #body {
    padding: 5vh 5vw;
  }
}

@keyframes slideFromLeft {
  from {
    transform: translateX(-90vw);
  }

  to {
    transform: translateX(0);
  }
}

#services-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  animation: slideFromLeft 0.23s forwards linear;
}

#profile-dropdown {
  position: absolute;
  top: 69px;
  right: 20px;
  z-index: 201;
}

.profile-dropdown-without-lang-select {
  top: 18px !important;
}

#language-select {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  z-index: 202;
}

#enter-prompt {
  position: absolute;
  top: 69px;
  right: 20px;
  z-index: 201;
}

.enter-prompt-without-lang-select {
  top: 20px !important;
}

@media screen and (max-width: 1018px) {
  #profile-dropdown {
    top: 73px;
  }

  #enter-prompt {
    top: 71px;
  }

  #language-select {
    left: unset;
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 201;
  opacity: 1;
}

#store-info {
  position: absolute;
  top: 20vh;
  right: 20px;
  width: 30%;
  min-width: 400px;
  background: white;
  border-radius: 10px;
  border-radius: 18px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24), 2px 2px 4px rgba(0, 0, 0, 0.36);
}
@media (max-width: 1200px) {
  #store-info {
    top: 15vh;
  }
}
@media (max-width: 1018px) {
  #store-info {
    top: 165px;
    width: 90%;
    left: 5%;
    min-width: 200px;
    max-height: 112px;
  }
}

@media screen and (max-width: 350px) {
  #store-info {
    top: 140px;
  }
}
</style>